<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <router-link class="text-decoration--none" :to="{ name: 'groups' }">
          Groups
        </router-link>
        <template v-if="group">
          <v-icon> {{ icons.arrow }} </v-icon>
          <span>{{ group.name }}</span>
        </template>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4">
      <group-form ref="form" :group="group"></group-form>
    </div>
  </div>
</template>

<script>
import Group from '@/models/Group'
import { mdiChevronRight } from '@mdi/js'
import GroupForm from '@/components/GroupForm'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'EditGroup',

  components: {
    GroupForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrow: mdiChevronRight
      },
      loading: false,
      group: null,
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  mounted() {
    this.getGroup()
  },

  methods: {
    getGroup() {
      Group.$find(this.$route.params.id)
        .then(group => (this.group = group))
        .catch(() => this.$router.replace({ name: 'groups' }))
    }
  }
}
</script>
